import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';

export default React.createClass({
  displayName: 'VerticalValueSelector',

  propTypes: {
    value: React.PropTypes.any.isRequired,
    displayValue: React.PropTypes.any,
    options: React.PropTypes.object.isRequired,
    onBlur: React.PropTypes.func,
    onChange: React.PropTypes.func.isRequired,
    textInput: React.PropTypes.bool,
    initialFocus: React.PropTypes.bool,
    mobile: React.PropTypes.bool,
    typePrefix: React.PropTypes.string,
  },

  getInitialState() {
    return {
      // Needed, to access ref on mount
      verticalInputRef: null,
      hasFocus: false,
      inputValueChanged: false,
    };
  },

  getDefaultProps() {
    return {
      initialFocus: false,
      mobile: false,
    };
  },

  componentDidMount() {
    this.setState({
      verticalInputRef: this.verticalInput,
      originalValue: this.props.value,
    });
  },

  render() {
    const {
      displayValue,
      mobile,
      typePrefix,
      options,
      initialFocus,
      length,
      onBlur,
      onTab,
      meridiem,
    } = this.props;

    let { value } = this.props;

    const { verticalInputRef, hasFocus, inputValueChanged } = this.state;

    let valueNode = displayValue || value;

    if (value.toString().length === 1) {
      if (!hasFocus || (hasFocus && !inputValueChanged)) {
        value = `0${value}`;
      }
    }

    let arrowUpNode = null,
      arrowDownNode = null;

    if (initialFocus) {
      if (verticalInputRef) {
        verticalInputRef.select();
      }
    }

    if (mobile) {
      arrowUpNode = (
        <div className="vertical-value-button">
          <Icon onClick={this._handleArrowKeyUp} size={2} name="angle-up" />
        </div>
      );

      arrowDownNode = (
        <div className="vertical-value-button">
          <Icon onClick={this._handleArrowKeyDown} size={2} name="angle-down" />
        </div>
      );
    }

    if (this.props.textInput) {
      let prefix = mobile ? typePrefix : '';

      valueNode = mobile ? (
        <span>{value}</span>
      ) : (
        <span>
          <input
            ref={(c) => (this.verticalInput = c)}
            autoFocus={initialFocus}
            onClick={(e) => e.target.select()}
            maxLength={length}
            onKeyDown={(e) => {
              // keyCode 40 - down arrow
              if (e.keyCode === 40) {
                this._handleArrowKeyDown();

                // keyCode 13 - enter
              } else if (onBlur && e.keyCode === 13) {
                onBlur();

                // keyCode 8 - backspace
              } else if (e.keyCode === 8) {
                e.preventDefault();
                this._handleBackspace(e.target);

                // keyCode 38 - up arrow
              } else if (e.keyCode === 38) {
                this._handleArrowKeyUp();

                // keyCode 9 - tab
              } else if (e.keyCode === 9) {
                if (typePrefix === 's' && !meridiem) {
                  e.preventDefault();
                  onTab();
                }

                /**``
                 * setState needed to fix min & sec bugs needing
                 * actual click selection to input double digits
                 */
                this.setState({
                  verticalInputRef: null,
                });

                let { value } = e.target;
                if (value.length === 1) {
                  e.target.value = (value < 10 ? '0' : '') + value;
                }

                if (onBlur && typePrefix === 's' && !meridiem) {
                  onBlur();
                }
              }
            }}
            type="text"
            value={value}
            onBlur={(e) => {
              this.setState({
                hasFocus: false,
              });
              let { value } = e.target;
              if (value.length === 1) {
                e.target.value = (value < 10 ? '0' : '') + value;
              }

              /**
               * Use of onChange will set the state.value of parent component
               * as well as state.valueChanged so that onBlur, this.props.value is the
               * updated controlled value
               */
              this.props.onChange(value);
            }}
            onFocus={(e) => {
              this.setState({
                hasFocus: true,
                verticalInputRef: null,
              });
              e.target.select();
            }}
            onChange={(e) => {
              if (e.target.value > options.size) {
                e.target.value =
                  options.size === 60 || options.size === 1440
                    ? options.size - 1
                    : options.size;
              }
              this.props.onChange(e.target.value);
              this.setState({
                verticalInputRef: null,
                inputValueChanged: true,
              });
            }}
          />
          <span className="vertical-value-prefix">{prefix}</span>
        </span>
      );
    }

    return (
      <div className="vertical-value-input">
        {arrowUpNode}
        <div className="vertical-value">{valueNode}</div>
        {arrowDownNode}
      </div>
    );
  },

  _handleArrowKeyDown() {
    const { value, options, onChange } = this.props;
    const indx = options.indexOf(value);
    let nextIndx = indx - 1;

    if (indx === 0) nextIndx = options.size - 1;

    onChange(options.get(nextIndx));
  },

  _handleBackspace(target) {
    const cursorIndex = target.selectionStart;
    const input = target.value;
    let newValue =
      input.substring(0, cursorIndex - 1) + input.substring(cursorIndex);

    if (!newValue || cursorIndex === 0) {
      newValue = '0';
    }

    const { onChange } = this.props;
    onChange(newValue);
  },

  _handleArrowKeyUp() {
    const { value, options, onChange } = this.props;

    const indx = options.indexOf(value);
    let nextIndx = indx + 1;

    if (indx >= options.size - 1) {
      nextIndx = 0;
    }

    onChange(options.get(nextIndx));
  },
});
